export default __webpack_public_path__ + "static/snowmobile-circle-809596f6bc820973a91f535e9e0d79b7.png";